import PosLandingReveal from './PosLandingReveal';
import PosLandingTick from './PosLandingTick';
import {
  LANDING_BRAND_NAME, LANDING_CHECKS, LANDING_CHIPS, LANDING_SECTIONS,
} from '../constants/posLandingConst';

/**
 * "Built around your counter": who it is for, and what a business sets up
 * as its own.
 *
 * @returns {JSX.Element}
 */
function PosLandingCustom() {
  return (
    <section id={LANDING_SECTIONS.custom}>
      <div className="wrap custom">
        <PosLandingReveal>
          <h2>Built around your counter, not someone else&apos;s</h2>
          <p className="lede" style={{ marginTop: 14 }}>
            {LANDING_BRAND_NAME} ships ready for whatever you sell. Set it up once and it speaks your business back to you — your items, your prices, your receipt, your people.
          </p>
          <div className="chips">
            {LANDING_CHIPS.map((chip) => <span className="chip" key={chip}>{chip}</span>)}
          </div>
          <div className="callout">
            <b>Need something the shelf version doesn&apos;t do?</b> {LANDING_BRAND_NAME} is built and maintained by The Website Pal, so a feature specific to how you trade is a conversation, not a support ticket that goes nowhere.
          </div>
        </PosLandingReveal>
        <PosLandingReveal as="ul" className="checks" delay={70}>
          {LANDING_CHECKS.map((check) => (
            <li key={check.title}>
              <PosLandingTick />
              <span><b>{check.title}</b><small>{check.body}</small></span>
            </li>
          ))}
        </PosLandingReveal>
      </div>
    </section>
  );
}

export default PosLandingCustom;
